<div class="container-fluid">
    <div class="row">
        <div class="col-12">
            <h4>
                <ng-container *ngTemplateOutlet="operation"></ng-container>
                <ng-container *ngTemplateOutlet="type"></ng-container>
                <strong>{{activityDetail?.SubjectName}}</strong>
            </h4>
        </div>
    </div>
    <hr>
    <section class="logs-content">
        <div class="row" *ngIf="activityDetail?.Properties.length > 0">
            <div class="col-12">
                <ng-container *ngTemplateOutlet="properties"></ng-container>
            </div>
        </div>
        <div class="row" *ngIf="activityDetail?.RelatedItems?.length > 0" [ngSwitch]="activityDetail?.SubjectType">
            <div class="col-12">
                <ng-container *ngSwitchCase="'User'">
                    <ng-container *ngTemplateOutlet="User"></ng-container>
                </ng-container>
                <ng-container *ngSwitchCase="'Group'">
                    <ng-container *ngTemplateOutlet="Group"></ng-container>
                </ng-container>
                <ng-container *ngSwitchCase="'Workflow'">
                    <ng-container *ngTemplateOutlet="workflowStages"></ng-container>
                </ng-container>
                <ng-container *ngSwitchCase="'RecipientEntity'">
                    <ng-container *ngTemplateOutlet="RecipientEntity"></ng-container>
                </ng-container>
            </div>
        </div>
    </section>
    <section class="logs-footer">
        <div class="row modal-actions">
            <div class="col align-items-end modal-footer">
                <button type=" button" class="btn btn-secondary" data-dismiss="modal" (click)="close();">Fermer</button>
            </div>
        </div>
    </section>
</div>

<ng-template #properties>
    <table class="properties-logs">
        <thead>
            <td class="tbl-field">Champs</td>
            <td class="tbl-field-oldvalue">Ancienne valeur</td>
            <td class="tbl-field-newvalue">Nouvelle valeur</td>
        </thead>
        <tbody>
            <tr *ngFor="let item of activityDetail?.Properties">
                <td>
                    <span class="properties-label">{{item.Field | friendlyName}}</span></td>
                <td>
                    <div [innerHTML]="item.OldValue"></div>
                </td>
                <td>
                    <div [innerHTML]="item.NewValue"></div>
                </td>
            </tr>
        </tbody>
    </table>
    <hr>
</ng-template>


<ng-template #RecipientEntity>
    <div class="related-items-type-label">Groupes de supervisions</div>
    <div class="row">
        <div class="col">
            <li *ngFor="let property  of getRelatedGroup('RecipientEntitySupervisionGroups', 1)">
                <span mat-dialog-title>Ajout du groupe {{ property?.SubjectName }}</span>
            </li>
        </div>
        <div class="col">
            <li *ngFor="let property  of getRelatedGroup('RecipientEntitySupervisionGroups', 3)">
                <span mat-dialog-title>Suppression du groupe {{ property?.SubjectName }}</span>
            </li>
        </div>
    </div>
</ng-template>

<ng-template #User>
    <ng-container *ngTemplateOutlet="userGroup"></ng-container>
    <ng-container *ngTemplateOutlet="userGroupSupervisor"></ng-container>
</ng-template>

<ng-template #Group>
    <ng-container *ngTemplateOutlet="groupUsers"></ng-container>
</ng-template>

<ng-template #groupUsers>
    <div class="related-items-type-label">Utilisateurs du groupe</div>
    <div class="row">
        <div class="col">
            <li *ngFor="let property  of getRelatedGroup('UserGroups', 1)">
                <span mat-dialog-title>Ajout de l'utilisateur {{ property?.SubjectName }}</span>
            </li>
        </div>
        <div class="col">
            <li *ngFor="let property  of getRelatedGroup('UserGroups', 3)">
                <span mat-dialog-title>Suppression de l'utilisateur {{ property?.SubjectName }}
                </span>
            </li>
        </div>
    </div>
</ng-template>

<ng-template #workflowStages>
    <div class="related-items-type-label">Groupes de validation</div>
    <div class="row">
        <div class="col">
            <li *ngFor="let property  of getRelatedGroup('WorkflowStages', 1)">
                <span mat-dialog-title>Ajout de la validation au groupe {{ property?.SubjectName }}</span>
            </li>
        </div>
        <div class="col">
            <li *ngFor="let property  of getRelatedGroup('WorkflowStages', 3)">
                <span mat-dialog-title>Suppression de la validation groupe{{ property?.SubjectName }} </span>
            </li>
        </div>
    </div>
</ng-template>

<ng-template #userGroup>
    <div class="related-items-type-label">Groupes de l'utilisateur</div>
    <div class="row">
        <div class="col">
            <li *ngFor="let property of getRelatedGroup('UserGroups', 1)">
                <span mat-dialog-title>Affectation au groupe {{ property.SubjectName }}</span>
            </li>
        </div>
        <div class="col">
            <li *ngFor="let property of getRelatedGroup('UserGroups', 3)">
                <span mat-dialog-title>Désaffectation du {{ property.SubjectName }}
                </span>
            </li>
        </div>
    </div>
</ng-template>

<ng-template #userGroupSupervisor>
    <ng-container *ngIf="getRelatedGroup('SupervisedGroups', 2).length > 0">
        <div class="related-items-type-label">Référent</div>
        <div class="row">
            <div class="col">
                <li *ngFor="let property of getRelatedGroup('SupervisedGroups', 2)">
                    <ng-container *ngFor="let item of property.Properties">
                        <span *ngIf="item.NewValue">L'utilisateur a été nommé référent du groupe
                            {{ property.SubjectName }}</span>
                        <span *ngIf="item.OldValue">L'utilisateur n'est plus référent du groupe
                            {{ property.SubjectName }}</span>
                    </ng-container>
                </li>
            </div>
        </div>
    </ng-container>
</ng-template>

<ng-template #type>
    <ng-container [ngSwitch]="activityDetail?.SubjectType">
        <span *ngSwitchCase="'Workflow'">du flux de validation </span>
        <span *ngSwitchCase="'Group'">du groupe </span>
        <span *ngSwitchCase="'User'">de l'utilisateur </span>
        <span *ngSwitchCase="'EmailTemplate'">du template email </span>
        <span *ngSwitchCase="'Asset'">de la référence </span>
        <span *ngSwitchCase="'RecipientEntity'">de la société </span>
    </ng-container>
</ng-template>

<ng-template #operation>
    <ng-container [ngSwitch]="activityDetail?.OperationType">
        <span *ngSwitchCase="1">Ajout </span>
        <span *ngSwitchCase="2">Modification </span>
        <span *ngSwitchCase="3">Suppression </span>
    </ng-container>
</ng-template>
